import script from "./AuditorDetailsForm.vue?vue&type=script&setup=true&lang=js"
export * from "./AuditorDetailsForm.vue?vue&type=script&setup=true&lang=js"

import "./AuditorDetailsForm.vue?vue&type=style&index=0&id=65955296&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65955296"]])

export default __exports__